export default {
  // any array should have unique values as the values are used as keys
  // months
  formattedShortMonths: [
    'Gen',
    'Feb',
    'Mar',
    'Apr',
    'Mag',
    'Giu',
    'Lug',
    'Ago',
    'Set',
    'Ott',
    'Nov',
    'Dic',
  ],
  months: [
    'Gennaio',
    'Febbraio',
    'Marzo',
    'Aprile',
    'Maggio',
    'Giugno',
    'Luglio',
    'Agosto',
    'Settembre',
    'Ottobre',
    'Novembre',
    'Dicembre',
  ],
  // weekdays
  weekdays: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
  weekdays_booking_container: {
    Sunday: 'Domenica',
    Monday: 'Lunedì',
    Tuesday: 'Martedì',
    Wednesday: 'Mercoledì',
    Thursday: 'Giovedì',
    Friday: 'Venerdì',
    Saturday: 'Sabato',
  },
  weekdays_calendar: {
    Sun: 'Dom',
    Mon: 'Lun',
    Tue: 'Mar',
    Wed: 'Mer',
    Thu: 'Gio',
    Fri: 'Ven',
    Sat: 'Sab',
  },
  // additional translations
  date: 'Data',
  today: 'Oggi',
  tomorrow: 'Domani',
};
